/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  CreateMyAgentOrganizationMutationRequest,
  CreateMyAgentOrganizationMutationResponse,
} from "../types/CreateMyAgentOrganization.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const createMyAgentOrganizationMutationKey = () =>
  [{ url: "/v1/user-onboarding/me/agent-organization" }] as const

export type CreateMyAgentOrganizationMutationKey = ReturnType<
  typeof createMyAgentOrganizationMutationKey
>

/**
 * @description Supplier portal users only. Creates a new organization for the agent and reassigns the user when their current organization matches the invited organization. Otherwise updates the existing user organization profile.
 * @summary Create current user agent organization during onboarding
 * {@link /v1/user-onboarding/me/agent-organization}
 */
export async function createMyAgentOrganization(
  data: CreateMyAgentOrganizationMutationRequest,
  config: Partial<RequestConfig<CreateMyAgentOrganizationMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateMyAgentOrganizationMutationResponse,
    ResponseErrorConfig<Error>,
    CreateMyAgentOrganizationMutationRequest
  >({
    method: "POST",
    url: `/v1/user-onboarding/me/agent-organization`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function createMyAgentOrganizationMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<CreateMyAgentOrganizationMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = createMyAgentOrganizationMutationKey()
  return mutationOptions<
    ResponseConfig<CreateMyAgentOrganizationMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateMyAgentOrganizationMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return createMyAgentOrganization(data, config)
    },
  })
}

/**
 * @description Supplier portal users only. Creates a new organization for the agent and reassigns the user when their current organization matches the invited organization. Otherwise updates the existing user organization profile.
 * @summary Create current user agent organization during onboarding
 * {@link /v1/user-onboarding/me/agent-organization}
 */
export function useCreateMyAgentOrganization<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<CreateMyAgentOrganizationMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: CreateMyAgentOrganizationMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<
      RequestConfig<CreateMyAgentOrganizationMutationRequest>
    > & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? createMyAgentOrganizationMutationKey()

  const baseOptions = createMyAgentOrganizationMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<CreateMyAgentOrganizationMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateMyAgentOrganizationMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<CreateMyAgentOrganizationMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateMyAgentOrganizationMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<CreateMyAgentOrganizationMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateMyAgentOrganizationMutationRequest },
    TContext
  >
}
